import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SeismicOMLDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-seismic-oml',
  templateUrl: './seismic-oml.component.html',
  styleUrls: ['./seismic-oml.component.scss'],
})
export class SeismicOMLComponent implements OnChanges {
  oilmineralleaseForm: FormGroup;
  oilmineralleaseFormArray: FormGroup;
  control = new FormControl();
  @Input() oilmineralleases: SeismicOMLDto[];
  @Input() routeAnimationsElements: any;
  @Output() oilminerallease = new EventEmitter<SeismicOMLDto[]>();
  @Output() deleteOilMineralLeaseEvent = new EventEmitter<any>();

  selectedOilMineralLease: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createOilMineralLeaseForm();
  }

  createOilMineralLeaseForm() {
    this.oilmineralleaseForm = this.fb.group({
      OilMineralLeaseName: ['', Validators.required],
      id: null,
    });
    this.oilmineralleaseFormArray = this.fb.group({
      OilMineralLeases: this.fb.array([]),
    });
    this.setOilMineralLease();
  }

  // method to display oilmineralleases
  setOilMineralLease() {
    const control = this.oilmineralleaseFormArray.controls
      .OilMineralLeases as FormArray;
    this.oilmineralleases.forEach((e) => {
      control.push(
        this.fb.group({
          OilMineralLeaseName: e.OilMineralLeaseName,
          id: e.id,
        })
      );
    });
  }

  // method to add OilMineralLease
  addOilMineralLease(value: SeismicOMLDto) {
    const control = this.oilmineralleaseFormArray.controls
      .OilMineralLeases as FormArray;
    control.insert(
      0,
      this.fb.group({
        OilMineralLeaseName: value.OilMineralLeaseName,
        id: null,
      })
    );
  }

  selectOilMineralLease(value) {}

  // method to delete oilminerallease from arrary list
  deleteOilMineralLease(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.oilmineralleaseFormArray.controls
          .OilMineralLeases as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.oilmineralleases.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.oilmineralleases[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: SeismicOMLDto) {
    if (this.oilmineralleaseForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.oilmineralleaseFormArray
        .get('OilMineralLeases')
        ['controls'][this.selectedIndex].patchValue({
          OilMineralLeaseName: formValue.OilMineralLeaseName,
        });
    } else {
      this.addOilMineralLease(formValue);
    }
    this.selectedIndex = null;
    this.oilmineralleaseForm.reset();
  }

  onEdit(index, value: SeismicOMLDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.oilmineralleaseForm.patchValue({
      OilMineralLeaseName: value.OilMineralLeaseName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.oilmineralleaseForm.reset();
  }

  onSubmit(formValue: SeismicOMLDto[]) {
    this.oilminerallease.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteOilMineralLeaseEvent.emit(this.filteredDelete);
    }
  }
}
